import { type HttpClient } from '../useHttpClient';

export interface PostChannelCreateParams {
  userIds: number[];
  operatorIds?: number[];
  name: string;
  isSuper?: boolean;
}

export const postChannelCreate =
  (httpClient: HttpClient) =>
  async ({
    userIds,
    operatorIds = [],
    name,
    isSuper = false,
  }: PostChannelCreateParams) =>
    await httpClient.api('/sendbird/channels', {
      method: 'POST',
      body: JSON.stringify({ userIds, operatorIds, name, isSuper }),
    });
